import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// --- Public ---
export const submitRsvp = (payload) => axios.post(`${API}/rsvp`, payload);
export const submitAccommodation = (payload) =>
  axios.post(`${API}/accommodation`, payload);
export const fetchContent = () => axios.get(`${API}/content`);
export const imageUrl = (imageId) =>
  imageId ? `${API}/images/${imageId}` : null;

// --- Admin ---
const ADMIN_KEY = "ca_admin_pwd";

export const setAdminPassword = (pwd) => sessionStorage.setItem(ADMIN_KEY, pwd);
export const getAdminPassword = () => sessionStorage.getItem(ADMIN_KEY) || "";
export const clearAdminPassword = () => sessionStorage.removeItem(ADMIN_KEY);

const adminHeaders = () => ({
  headers: { "X-Admin-Password": getAdminPassword() },
});

export const adminLogin = (password) =>
  axios.post(`${API}/admin/login`, { password });

export const adminSaveContent = (data) =>
  axios.put(`${API}/admin/content`, { data }, adminHeaders());

export const adminFetchRsvps = () => axios.get(`${API}/rsvp`, adminHeaders());
export const adminFetchAccommodations = () =>
  axios.get(`${API}/accommodation`, adminHeaders());
export const adminFetchStats = () => axios.get(`${API}/stats`, adminHeaders());

export const adminUploadImage = (file, onProgress) => {
  const form = new FormData();
  form.append("file", file);
  return axios.post(`${API}/admin/upload`, form, {
    headers: {
      ...adminHeaders().headers,
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress: (e) => {
      if (onProgress && e.total) {
        onProgress(Math.round((e.loaded / e.total) * 100));
      }
    },
  });
};
